module.exports = __webpack_public_path__ + "496674041f00dfb534e6b60d521774db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/features/screens/walk/large.png
// module id = 1823
// module chunks = 1